import '../css/pricing.css';
import '../css/background.css';
import Navbar from '../components/Navbar.jsx';
import Footer from '../components/Footer.jsx';

function Pricing(props) {

    return (
        <div className="background-shapes">
            <div className="pricing">
                <Navbar currentComponent={props.currentComponent} setCurrentComponent={props.setCurrentComponent} />
                
                <h1>Areas Serving</h1>

                <div className="areas-serving">
                    <div>
                        <ul>
                            <li>Gulfport</li>
                            <li>Indian Rocks Beach</li>
                            <li>Indian Shores</li>
                            <li>Kenneth City</li>
                            <li>Largo</li>
                            <li>Madeira Beach</li>
                            <li>Belleair</li>
                            <li>Belleair Beach</li>
                            <li>Belleair Bluffs</li>
                            <li>Belleair Shore</li>
                            <li>Clearwater</li>
                            <li>Dunedin</li>
                        </ul>
                    </div>

                    <div>
                        <ul>
                            <li>North Redington Beach</li>
                            <li>Oldsmar</li>
                            <li>Pinellas Park</li>
                            <li>Redington Beach</li>
                            <li>Redington Shores</li>
                            <li>Safety Harbor</li>
                            <li>St. Pete Beach</li>
                            <li>St. Petersburg</li>
                            <li>Seminole</li>
                            <li>South Pasadena</li>
                            <li>Tarpon Springs</li>
                            <li>Treasure Island</li>
                        </ul>
                    </div>
                </div>

                <p>$150/hour</p>
                <p>$2,500 deposit required for entire home</p>
                <p>*Willing to travel for clients, please contact me for more information</p>

            </div>

            <Footer />
        </div>
    );
}

export default Pricing;